import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Container, Navbar, NavbarBrand } from "shards-react";

import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarSearch from "./NavbarSearch";
import NavbarToggle from "./NavbarToggle";

import { LAYOUT_TYPES } from "../../../utils/constants";

const MainNavbar = ({ layout, stickyTop }) => {
  const isHeaderNav = layout === LAYOUT_TYPES.HEADER_NAVIGATION;
  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );

  return (
    <div className={classes}>
      <Container fluid={!isHeaderNav || null} className="p-0">
        <Navbar stype="light" className="align-items-stretch flex-md-nowrap p-0" style={{justifyContent:'end'}}>
          {isHeaderNav && (
            <NavbarBrand href="#" style={{ lineHeight: "25px" }}>
              <div className="d-table m-auto">
                <img
                  id="main-logo"
                  className="d-inline-block align-top mr-1 ml-3"
                  style={{ maxWidth: "25px" }}
                  src= "http://mymurmuration.theswiftstudio.com/wp-content/uploads/2022/05/image001-1.png"//"http://murmuratto.com/wp-content/uploads/2022/05/image001-2.png"//{require("../../../images/shards-dashboards-logo.svg")}
                  alt="Shards Dashboard"
                />
                <span className="d-none d-md-inline ml-1">
                  Murmuratto
                </span>
              </div>
            </NavbarBrand>
          )}
          <NavbarSearch />
          <NavbarNav/>
          <NavbarToggle />
        </Navbar>
      </Container>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};

MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
